import { Loading } from '@/shared/types/Loading'
import type { Order } from './Order'
import type { Picking } from './Picking'

import { PaymentStatusType } from '@/domain/PaymentStatus'
import { OrderStatus } from '@/domain/OrderStatus'
import { UserType } from '@/shared/types/UserType'
import { ContactlessType } from '@/domain/ContactlessType'

export interface StatusState {
  immutable: {
    order: Order
    picking: Picking
  }
  loading: {
    loadOrder: Loading
  }
}

const orderDefault: Order = {
  id: '',
  reference: '',
  clientId: '',
  storeReference: '',
  operationalModel: '',
  status: OrderStatus.CREATED,
  source: '',
  deliveryCode: '',
  comment: '',
  origin: {
    name: '',
    city: '',
    address: '',
    location: {
      _lat: 0,
      _long: 0
    }
  },
  destination: {
    name: '',
    city: '',
    address: '',
    location: {
      _lat: 0,
      _long: 0
    }
  },
  route: {
    resourceId: '',
    routeId: ''
  },
  deliveryOptions: [],
  store: {
    id: '',
    name: '',
    reference: '',
    timeZone: ''
  },
  lastUpdated: new Date(),
  eta: { from: 0, to: 0 },
  tracking: {
    password: '',
    topic: '',
    username: ''
  },
  paymentInfo: {
    currencyCode: '',
    currencyCodeOrder: '',
    prices: {
      subtotal: '',
      shippingFee: '',
      taxes: '',
      discounts: '',
      orderValue: '',
      hasDiscount: false
    },
    payment: {
      value: ''
    },
    invoice: {
      reference: '',
      attachments: []
    }
  },
  payment: {
    method: {
      name: '',
      iconUrl: ''
    },
    status: {
      translateKey: '',
      iconUrl: '',
      cssClass: '',
      name: PaymentStatusType.IN_PROGRESS
    },
    transactions: []
  },
  users: [],
  user: {
    type: UserType.CLIENT,
    name: '',
    email: '',
    phone: '',
    photoUrl: ''
  },
  steps: [],
  createdAt: {
    seconds: 0,
    nanoseconds: 0
  },
  taskId: '',
  isAuditing: false,
  isPickAndDelivery: false,
  showDeliveryCode: false,
  isPickAndCollect: false,
  showPickupQR: false,
  isGoingToDestination: false,
  isOrderCancel: false,
  isOrderFinished: false,
  showChangeQuantity: false,
  deliveryCurbside: {
    vehicle: {
      color: '',
      plate: ''
    },
    user: {
      name: ''
    },
    parking: {
      location: ''
    },
    comment: ''
  },
  contactless: {
    type: ContactlessType.LEAVE_AT_DOOR,
    receptor: {
      name: '',
      phone: ''
    }
  },
  pickingIsInProgress: false
}

const pickingItemDefault = {
  quantity: 0,
  countProductsToReplace: 0,
  countProductsReplaced: 0,
  countProductsReplacement: 0,
  products: []
}

export const statusInitialState: StatusState = {
  immutable: {
    order: orderDefault,
    picking: {
      id: '',
      store_reference: '',
      showOrderLate: false,
      slot_info: {
        from: {
          seconds: 0,
          nanoseconds: 0
        },
        to: {
          seconds: 0,
          nanoseconds: 0
        }
      },
      added: pickingItemDefault,
      pending: pickingItemDefault,
      rejected: pickingItemDefault,
      removed: pickingItemDefault,
      replacementSuggestions: {}
    }
  },
  loading: {
    loadOrder: Loading.IDLE
  }
}
